<p-dialog
  [(visible)]="canShowPreviewModel"
  [contentStyle]="{ 'max-height': '50em', width: 'auto', 'z-index': '10030px' }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false"
  [style]="{ left: '10%', right: '10%' }"
  styleClass="preview-modal">
  <ng-template #header>
    <div class="ui-g-11">
      <span>Deal Association Document Preview</span>
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="closePreview()"
      (keydown.enter)="closePreview()"
      tabindex="0">
      <i class="mdl2-cancel close-icon"></i>
    </div>
  </ng-template>

  <div class="ui-g">
    <div class="ui-g-3 bg-color-1">
      <div class="mb-3">
        <div class="title">Incentive Id</div>
        <div>{{ incentivePreviewInput.engagementId }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Incentive Type</div>
        <div class="word-wrap">{{ incentivePreviewInput.incentiveName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Customer name/organization</div>
        <div class="word-wrap">
          {{ incentivePreviewInput.customerOrgName }}
        </div>
      </div>
      <div class="mb-3">
        <div class="title">Partner organization</div>
        <div class="word-wrap">{{ incentivePreviewInput.partnerOrgName }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Partner requestor email</div>
        <div class="word-wrap">
          {{ incentivePreviewInput.partnerInputRequestorEmail }}
        </div>
      </div>
      <div class="mb-3">
        <div class="title">Pre-sales Activity Date</div>
        <div>
          {{ incentivePreviewInput.committedDate | date: 'MM/dd/yyyy' }}
        </div>
      </div>
      <div class="mb-3">
        <div class="title">45 Day Expiration</div>
        <div>
          {{ incentivePreviewInput.day45ExpirationDate | date: 'MM/dd/yyyy' }}
        </div>
      </div>
      <div class="mb-3">
        <div class="title">Incentive Expiration Date</div>
        <div>
          {{
            incentivePreviewInput.incentiveExpirationDate | date: 'MM/dd/yyyy'
          }}
        </div>
      </div>
      <div class="mb-3">
        <div class="title">Type</div>
        <div>Deal Association Document</div>
      </div>
      <div class="mb-3">
        <div class="title">Status</div>
        <div>{{ documentStatus }}</div>
      </div>
      <div class="mb-3">
        <div class="title">Upload Date</div>
        <div>{{ documentUploadedDate }}</div>
      </div>
    </div>

    <div class="ui-g-9 file-viewer">
      @if (isDocumentPreviewLoading && downloadSpin) {
        <div class="mh">
          <p-progressSpinner
            [style]="{ width: '100px', height: '100px' }"
            strokeWidth="5"
            fill="#EEEEEE"
            animationDuration=".5s"></p-progressSpinner>
        </div>
      }
      @if (!downloadSpin) {
        <div>
          <div class="no-preview-position">
            <label for="no-file-preview">No file to preview</label>
            <input type="hidden" id="no-file-preview" />
          </div>
        </div>
      }
      @if (!isDocumentPreviewLoading) {
        <div>
          <app-preview-file
            [fileContentModel]="fileContentModel"
            [engagementPreviewInput]="$any(incentivePreviewInput)">
          </app-preview-file>
        </div>
      }
    </div>
  </div>

  <p-dialog
    [(visible)]="invoiceRejectionModalDisplay"
    [contentStyle]="{
      'max-height': '50em',
      width: 'auto',
      'z-index': '1038px'
    }"
    [closable]="false"
    [draggable]="false"
    showEffect="fade"
    [modal]="false"
    class="modal-position">
    <ng-template #header>
      <div class="ui-g-11">
        <span>Select reasons to reject the document</span>
      </div>
      <div
        class="ui-g-1 closesidebar diaclnav"
        (click)="closeDeclineModal()"
        (keydown.enter)="closeDeclineModal()"
        tabindex="0">
        <i class="mdl2-cancel close-icon"></i>
      </div>
    </ng-template>
    <form [formGroup]="formInvoiceRejection">
      <div class="mb-3">
        <div class="title">Reasons</div>
        <p-multiSelect
          appendTo="body"
          name="invoiceRejectionList"
          placeholder="Select reason for rejecting the invoice"
          [maxSelectedLabels]="2"
          [options]="invoiceRejectionList"
          optionLabel="reason"
          formControlName="invoiceRejectionReason"></p-multiSelect>
      </div>
      <div class="mb-3">
        <div class="title">Additional Notes (Optional)</div>
        <div>
          <textarea
            pTextarea
            formControlName="additionalNotesRejectionReason"
            class="additional-notes p-1"
            placeholder="Enter Notes"
            rows="5"
            name="additionalNotes"
            maxlength="250"
            aria-label="additionalnotes"></textarea>
          <small class="form-text text-muted">
            <code>{{
              formInvoiceRejection.controls['additionalNotesRejectionReason']
                .value
                ? formInvoiceRejection.controls[
                    'additionalNotesRejectionReason'
                  ].value.length
                : 0
            }}</code>
            of <code>250</code> characters
          </small>
        </div>
      </div>
      <button
        type="button"
        pTooltip="Ok"
        [disabled]="!invoiceDenyButtonEnable"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-ok"
        pButton
        (click)="onDeny()">
        Ok
      </button>
      <button
        type="button"
        pTooltip="Cancel"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-cancel"
        pButton
        (click)="closeDeclineModal()">
        Cancel
      </button>
    </form>
  </p-dialog>
  <div class="ui-g">
    <div class="ui-g-2"></div>
    <div class="ui-g-10">
      @for (message of msgsUsageDetails; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
    </div>
    <div class="ui-g-2"></div>
    <div class="ui-g-1">
      <input
        class="next-previous"
        [disabled]="!checkForPrevious()"
        (click)="onPreviousClick()"
        type="button"
        value="« Previous" />
    </div>
    <div class="ui-g-8 center">
      <button
        type="button"
        pButton
        (click)="onDenyOpen()"
        pTooltip="Reject"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-deny">
        Reject
      </button>
      <button
        type="button"
        pButton
        (click)="submitForApproval()"
        pTooltip="Approve"
        tooltipPosition="top"
        class="ui-button-info btnpad btnmr button-approve">
        Approve
      </button>
    </div>
    <div class="ui-g-1">
      <input
        class="next-previous"
        [disabled]="!checkForNext()"
        (click)="onNextClick()"
        type="button"
        value="Next »" />
    </div>
  </div>
</p-dialog>
